import React from 'react';
import { Link } from 'react-router-dom';

const Service = ({ title, price, desc, img, shopLink }) => {
    const scrollTo = (to) => {
        // Basic check to ensure the element exists before scrolling
        const element = document.getElementById(to);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.warn(`Element with id "${to}" not found for scrolling.`);
        }
    }

  return (
    <div
      className='
        flex flex-col bg-gray-900 text-white rounded-lg overflow-hidden shadow-lg
        transform transition duration-300 ease-in-out hover:scale-105
      ' // Added transition and hover scale classes
    >
      {/* Image Section */}
      <div
        className='w-full h-48 bg-cover bg-center'
        style={{ backgroundImage: `url(${img})` }}
      ></div>

      {/* Content Section */}
      <div className='p-4 flex flex-col justify-between flex-grow'>
        <div>
          {/* Title */}
          <h2 className='text-xl font-bold mb-2'>{title}</h2>

          {/* Price */}
          <p className='text-4xl font-semibold mb-2'>
            {price}
            {/* Conditionally render Euro sign only if price exists and is not empty */}
            {price && <span className='text-sm'>€</span>}
          </p>

          {/* Description */}
          <p className='text-sm text-gray-300'>{desc}</p>
        </div>

        {/* Button - either shop link or contact scroll */}
        <div className='mt-4'>
            <button
              onClick={() => scrollTo('contactform')}
              className='w-full bg-green-400 text-black py-2 px-4 rounded-lg hover:bg-green-600 transition-colors'
            >
              Sazināties
            </button>
        </div>
      </div>
    </div>
  );
};

export default Service;